import '../styles/ImageCard.css';

function ImageCard({ imageRep, url, desc, brand }) {
  return (
    <article className="ImageCard-Background">
      <div className="ImageCard-Logo">
        <img src={imageRep} className="ImageCard-IMG" alt={`${brand} logo`} />
      </div>
      <h3 className="ImageCard-Title">{brand}</h3>
      <p className="ImageCard-Desc">{desc}</p>
      <a href={url} target="_blank" rel="noreferrer" className="ImageCard-Learn">
        Visit manufacturer <span aria-hidden="true">↗</span>
      </a>
    </article>
  );
}

export default ImageCard;
